<template>
  <v-container>
    <v-card flat v-if="page !== 'PaymentInformation'">
      <v-container>
        <h1 class="earth-color text-md-center text-sm-center">
          BOOKING SUMMARY
        </h1>
        <h3 class="earth warning--text text-md-center text-sm-center">
          {{ reservation.check_in }} - {{ reservation.check_out }}
        </h3>
        <v-container fluid>
          <v-flex md12>
            <v-list subheader>
              <v-subheader
                ><span class="earth-color"
                  >CONSERVATION ENTRY FEES</span
                ></v-subheader
              >
              <v-list-tile
                v-for="(guest, key) in allConservationFees"
                :key="key"
                v-if="guest.payment_guests > 0"
              >
                <v-list-tile-content>
                  <v-list-tile-title
                    >{{ guest.payment_person }} x
                    {{ allConservationFees[key].payment_guests }} <br />x
                    {{ days }} night(s)</v-list-tile-title
                  >
                  <v-list-tile-sub-title
                    >{{ browserCurrency }}
                    {{
                      Math.round(
                        convertConservation(allConservationFees[key])
                      ).toLocaleString("en")
                    }}</v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title
                    >Conservation Entry Fee Total:
                    <b
                      >{{ browserCurrency }}
                      {{
                        Math.round(conservationTotal).toLocaleString("en")
                      }}</b
                    ></v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
          <hr v-if="$vehicleDisabled === false" />
          <v-flex md12 v-if="$vehicleDisabled === false">
            <v-list subheader>
              <v-subheader
                ><span class="earth-color">VEHICLE FEES</span></v-subheader
              >
              <v-list-tile
                v-for="(vehicle, key) in allVehicles"
                :key="key"
                v-if="vehicle.vehicles > 0"
              >
                <v-list-tile-content>
                  <v-list-tile-title
                    >{{ vehicle.vehicle_charge_category }} x
                    {{ allVehicles[key].vehicles }} vehicles <br />x
                    {{ days }} night(s)</v-list-tile-title
                  >
                  <v-list-tile-sub-title>{{
                    convertVehicle(vehicle)
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title
                    >Vehicle Fee Total:
                    <b
                      >{{ browserCurrency }}
                      {{ Math.round(vehicleTotal).toLocaleString("en") }}</b
                    ></v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
          <hr />
          <v-list subheader>
            <v-subheader
              ><span class="earth-color">ACCOMMODATION</span></v-subheader
            >
            <v-container v-if="chosenFacilities.length === 0">
              <p>No Accommodation Selected</p>
            </v-container>
            <v-list-tile
              v-for="(facility, key) in chosenFacilities"
              :key="key"
              v-if="chosenFacilities.length > 0"
            >
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ facility.name }} x
                  {{ getDays(facility.start_date, facility.end_date) }}
                  Nights</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >{{ browserCurrency }}
                  {{
                    Math.round(facilityTotal(facility)).toLocaleString("en")
                  }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
              <v-list-tile-avatar>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  round
                  @click="removeFacility(facility)"
                  >x</v-btn
                >
              </v-list-tile-avatar>
            </v-list-tile>
            <v-list-tile v-if="chosenFacilities.length > 0">
              <v-list-tile-content>
                <v-list-tile-title
                  >Accommodation Total:
                  <b
                    >{{ browserCurrency }}
                    {{ Math.round(allFacilityTotal).toLocaleString("en") }}</b
                  ></v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <hr />
          <v-list subheader>
            <v-subheader
              ><span class="earth-color"
                >CONSERVATION ACTIVITIES</span
              ></v-subheader
            >
            <v-container v-if="chosenInventory.length === 0">
              <p>No Conservation Activities Selected</p>
            </v-container>
            <v-list-tile
              v-for="(inventory, index) in chosenInventory"
              :key="index"
              v-if="chosenInventory.length > 0"
            >
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ inventory.name }} on
                  {{ formated_date(inventory.date) }}</v-list-tile-title
                >
                <v-list-tile-sub-title v-if="inventory.ranger_marker === false &&  inventory.adults > 0 && inventory.children > 0 "
                  >{{inventory.residency_adult. payment_person}}: {{ inventory.adults }}, {{inventory.residency_children. payment_person}}:
                  {{ inventory.children }}</v-list-tile-sub-title
                >
                 <v-list-tile-sub-title v-else-if="inventory.ranger_marker === false &&  inventory.adults > 0"
                  >{{inventory.residency_adult.payment_person}}: {{ inventory.adults }}
                  </v-list-tile-sub-title
                >
                 <v-list-tile-sub-title v-else-if="inventory.ranger_marker === false &&  inventory.children > 0"
                  >{{inventory.residency_children.payment_person}}: {{ inventory.children }}
                  </v-list-tile-sub-title
                >
                <v-list-tile-sub-title v-else-if="inventory.ranger_marker === true"
                  >Rangers #: {{ inventory.adults }}</v-list-tile-sub-title
                >
                <v-list-tile-sub-title
                  >{{ browserCurrency }}
                  {{
                    Math.round(findActivityTotal(inventory)).toLocaleString(
                      "en"
                    )
                  }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
              <v-list-tile-avatar>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  round
                  @click="removeInventory(index)"
                  >x</v-btn
                >
              </v-list-tile-avatar>
            </v-list-tile>
            <v-list-tile v-if="chosenInventory.length > 0">
              <v-list-tile-content>
                <v-list-tile-title
                  >Conservation Activities Total:
                  <b
                    >{{ browserCurrency }}
                    {{ Math.round(allInventoryTotal).toLocaleString("en") }}</b
                  ></v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <hr />
          <v-list>
            <v-subheader><span class="earth-color">DONATION</span></v-subheader>
            <v-container v-if="allPublicDonations.length <= 0">
              <p>No Donations</p>
            </v-container>
            <v-list-tile
              v-for="(donation, index) in allPublicDonations"
              :key="index"
              v-if="allPublicDonations.length > 0"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ donation.cause }}</v-list-tile-title>
                <v-list-tile-title
                  >{{ donation.currency_name }}
                  {{ donation.amount }}</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-avatar>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  round
                  @click="removeDonation(index)"
                  >x</v-btn
                >
              </v-list-tile-avatar>
            </v-list-tile>
          </v-list>
          <hr />
          <v-list v-if="proofOfResidency.length > 0">
            <v-subheader ><span class="earth-color">Proof Of Residency </span></v-subheader>
          
            <v-list-tile
              v-for="(proof, index) in proofOfResidency"
              :key="index"
            >
              <v-list-tile-content>
                <v-list-tile-title v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">{{ proof.first_name }} {{ proof.last_name }}</v-list-tile-title>
                <v-list-tile-title v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' "
                  >{{ proof.payment_person }}
                  {{ proof.document_id }}</v-list-tile-title
                >
              </v-list-tile-content>
              <!-- <v-list-tile-avatar>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  round
                  @click="removeProof(index)"
                  >x</v-btn
                >
              </v-list-tile-avatar> -->
            </v-list-tile>
          </v-list>
          <hr />
          <br />
          <h1 class="akzidenz">
            Total : {{ browserCurrency }}
            {{ Math.round(totalPrice).toLocaleString("en") }}
          </h1>
        </v-container>
      </v-container>
    </v-card>
    <v-card v-if="page === 'PaymentInformation'" flat>
      <v-container>
        <v-flex
          ><h3 class="text-lg-center text-md-center text-sm-center earth-color">
            Booking Total
          </h3></v-flex
        >
          <div
            class="text-xs-center"
            v-if="
              paymentUSDPrice ===undefined 
            "
            style="margin-top: 20px"
          >
            <line-scale-pulse-out-rapid-loader
              color="#73a533"
              size="50px"
            ></line-scale-pulse-out-rapid-loader>
          </div>
        <v-container  v-if="
              paymentUSDPrice !==undefined 
            ">
          <h1  class="earth-color text-center black--text">
            {{ browserCurrency }} {{ $roundOff(paymentUSDPrice) }}
          </h1>
        </v-container>

        <v-flex v-if="allOnlinepaymentDonations.length > 0"
          ><h5 class="text-lg-center text-md-center text-sm-center earth-color">
            Conservation Donation
          </h5></v-flex
        >
        <v-flex>
          <v-container v-if="allOnlinepaymentDonations.length > 0">
            <h1
              v-for="(donation, index) in allOnlinepaymentDonations"
              :key="index"
              class="earth-color text-center black--text"
            >
              {{ donation.new_donation_currency_name }}
              {{ donation.new_donation_amount }}
              <v-btn
                :depressed="true"
                color="error"
                small
                round
                @click="removeOnlineDonation(index)"
                >X</v-btn
              >
            </h1>
          </v-container>
        </v-flex>
      </v-container>
    </v-card>
    {{ bookingStatus }}
  </v-container>
</template>

<script>
import Guests from "./Guests";
export default {
  name: "side-bar",
  data() {
    return {
      route: "",
      page: this.$route.name,
      total: 0,
      route: this.$route.name,
      date_settings: {
        night: "Night",
        nights: "Nights",
        "day-names": ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
        "check-in": "Check-in",
        "check-out": "Check-Out",
        "month-names": [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
      reservation: {
        days: 0,
        // check_in: JSON.parse(localStorage.getItem("user_data")).check_in,
        // check_out: JSON.parse(localStorage.getItem("user_data")).check_out,
        currency: localStorage.getItem("currency"),
      },
      booking: false,
      donations: localStorage.getItem("donation"),
      // online_donation_amount: 0,
    };
  },
  computed: {
    days: function () {
      return Number(
        this.getDays(
          JSON.parse(localStorage.getItem("user_data")).check_in,
          JSON.parse(localStorage.getItem("user_data")).check_out
        )
      );
    },

    totalPrice: function () {
      var donationAmout = 0;
      if (this.allPublicDonations.length > 0) {
        if (this.allPublicDonations[0].currency === this.browserCurrencyID) {
          donationAmout = Number(this.allPublicDonations[0].amount);
        } else {
          if (
            this.browserCurrencyID === "6bf74e49-7ff6-4555-a080-15541d62204a"
          ) {
            // USD
            donationAmout = Number(this.allPublicDonations[0].amount);
          } else {
            // donationAmout = Number(this.allPublicDonations[0].amount) * 100;

            donationAmout = Number(
              this.convertBasedBookingCreationDate(
                this.allPublicDonations[0].currency_name,
                Number(this.allPublicDonations[0].amount),
                this.allPublicDonations[0].currency_buy_rate,
                this.allPublicDonations[0].currency_sell_rate
              ).amount
            );
          }
        }
      }

      // activity total
      var activity = 0;
      for (var i = 0; i < this.chosenInventory.length; i++) {
        activity = activity + this.findActivityTotal(this.chosenInventory[i]);
      }
      // facility total
      var facility = 0;
      for (var j = 0; j < this.chosenFacilities.length; j++) {
        facility =
          facility + Number(this.facilityTotal(this.chosenFacilities[j]));
      }
      // vehicle total
      var vehicleData = this.vehicleTotal;
      // conservation total
      var conservationData = this.conservationTotal;
      return (
        activity + facility + vehicleData + conservationData + donationAmout
      );
    },
    paymentKESPrice: function () {
      if (this.singleBooking.currency !== undefined) {
        var total = 0;
        total = this.convert2(
          this.singleBooking.currency,
          "KES",
          this.singleBooking.booking_payment_balance
        ).amount;
        return total;
      }
    },

    paymentUSDPrice: function () {
      
      let  donationAmout =this.totalOnlineDonations
      if (this.singleBooking.currency !== undefined) {
        var total = 0;
        total = Number(
          this.convertBasedBookingCreationDate(
            this.singleBooking.currency,
            this.singleBooking.booking_payment_balance,
            this.singleBooking.currency_buying_rate_at_time,
            this.singleBooking.currency_selling_rate_at_time
          ).amount
        );
         total = total + Math.ceil(donationAmout);
        return total;
      }
    },

   
  },
  created() {
    if (this.$route.name !== "PaymentInformation") {
      this.route = this.$route.name;
      this.$store.commit(
        "BOOKING_FACILITIES",
        JSON.parse(localStorage.getItem("facility_data"))
      );
      this.$store.commit(
        "CHOSEN_ACTIVITIES",
        JSON.parse(localStorage.getItem("activity_data"))
      );

      if (localStorage.getItem("conservation_data") !== null) {
        this.$store.commit(
          "LOCAL_CONSERVATION",
          JSON.parse(localStorage.getItem("conservation_data"))
        );
      }
      if (localStorage.getItem("vehicle_data") !== null) {
        this.$store.commit(
          "LOCAL_VEHICLES",
          JSON.parse(localStorage.getItem("vehicle_data"))
        );
      }
    }
    // if (localStorage.getItem('currency') !== null) {
    //   this.reservation.currency = JSON.parse(localStorage.getItem('currency'))
    // }
    // this.$store.state.PricingStore.inventory_selection = JSON.parse(localStorage.getItem('browser_inventory'))
  },
  components: {
    Guests,
  },
  methods: {
    convertVehicle: function (data) {
      var total = 0;
      total =
        this.convert1(
          data.vehicle_charge_cost_currency,
          data.vehicle_charge_category_cost
        ).amount * Number(data.vehicles);
      return (
        this.$store.state.CurrencyStore.browser_currency +
        " " +
        Number(total * this.days).toLocaleString("en")
      );
    },
    checkInDate: function (data) {
      var date = data;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.reservation.check_in = date;
    },
    checkOutDate: function (data) {
      var date = data;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.reservation.check_out = date;
      this.adjustDates(this.reservation.check_in, this.reservation.check_out);
    },
    selectAccomodation: function () {
      var selectedAccomodation = {
        public_id: this.singleFacility.public_id,
        facility_type: this.singleFacility.facility_type_id,
        accommodation_type: this.singleFacility.accomodation_type_id,
        analysis_code: this.singleFacility.analysis_code,
        start_date: JSON.parse(localStorage.getItem("user_data")).check_in,
        end_date: JSON.parse(localStorage.getItem("user_data")).check_out,
        name: this.singleFacility.name,
        adult_price: this.singleFacility.price.adult_price,
        child_price: this.singleFacility.price.child_price,
        mandatory_price: this.singleFacility.price.mandatory_price,
        children: 0,
        adults: this.getCoservationGuests(),
        currency: this.singleFacility.price.currency_type,
      };
      localStorage.setItem(
        "facility_data",
        JSON.stringify([selectedAccomodation])
      );
      this.$store.commit("BROWSER_FACILITIES", [selectedAccomodation]);
      //    this.$store.state.FacilityStore.browser_facilities = [prices]
      this.$router.push({
        name: "ActivitySelection",
      });
    },
  },
};
</script>

<style >
h5 {
  font-family: Arial;
}
/* Dropdown Button */

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #f1f1f1;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}
</style>
